/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualSubfields = exports.V1AppErrorCodes = exports.TranslatableType = exports.Sort = exports.ServiceAppendixType = exports.SegmentName = exports.ResetOffsetType = exports.RegistrationStatus = exports.ProxyDeployment = exports.PersistenceType = exports.PermissionType = exports.PartitionStatusStatus = exports.PagingType = exports.Ordering = exports.OptimizeMode = exports.Operator = exports.OffsetReset = exports.NullValue = exports.Method = exports.MessageAppendixType = exports.Maturity = exports.Label = exports.JSType = exports.IdempotencyLevel = exports.HttpStatusCode = exports.HeaderOperator = exports.Format = exports.FieldDescriptorProtoType = exports.FailureReason = exports.FailType = exports.Exposure = exports.DomainEventEventType = exports.DeliveryMethod = exports.DC = exports.ConsumerType = exports.ClusterEnumCluster = exports.CallbackEventType = exports.CType = exports.ApiCluster = exports.ApiAppErrorCodes = exports.AdHocConsumerStatusStatus = exports.AbacRequestValidationMode = void 0;
var AbacRequestValidationMode;
(function (AbacRequestValidationMode) {
    AbacRequestValidationMode["ON"] = "ON";
    AbacRequestValidationMode["OFF"] = "OFF";
})(AbacRequestValidationMode = exports.AbacRequestValidationMode || (exports.AbacRequestValidationMode = {}));
var AdHocConsumerStatusStatus;
(function (AdHocConsumerStatusStatus) {
    AdHocConsumerStatusStatus["PENDING"] = "PENDING";
    AdHocConsumerStatusStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AdHocConsumerStatusStatus["SUCCESS"] = "SUCCESS";
    AdHocConsumerStatusStatus["ERROR"] = "ERROR";
})(AdHocConsumerStatusStatus = exports.AdHocConsumerStatusStatus || (exports.AdHocConsumerStatusStatus = {}));
var ApiAppErrorCodes;
(function (ApiAppErrorCodes) {
    ApiAppErrorCodes["UNKNOWN"] = "UNKNOWN";
    ApiAppErrorCodes["NO_CONSUMER_FOR_TOPIC"] = "NO_CONSUMER_FOR_TOPIC";
    ApiAppErrorCodes["NO_CONSUMER_FOR_GROUP"] = "NO_CONSUMER_FOR_GROUP";
    ApiAppErrorCodes["HANDLER_FAILED"] = "HANDLER_FAILED";
    ApiAppErrorCodes["HANDLER_NOT_RETRIABLE"] = "HANDLER_NOT_RETRIABLE";
    ApiAppErrorCodes["CONSUMER_STOPPED"] = "CONSUMER_STOPPED";
    ApiAppErrorCodes["USER_ALREADY_REGISTERED"] = "USER_ALREADY_REGISTERED";
    ApiAppErrorCodes["EMPTY_GENERATION_ID"] = "EMPTY_GENERATION_ID";
    ApiAppErrorCodes["PRODUCE_TIMEOUT"] = "PRODUCE_TIMEOUT";
    ApiAppErrorCodes["CONSUMER_NOT_STARTED"] = "CONSUMER_NOT_STARTED";
    ApiAppErrorCodes["USER_NOT_REGISTERED"] = "USER_NOT_REGISTERED";
    ApiAppErrorCodes["CONSUMER_CONFIG_COLLISION"] = "CONSUMER_CONFIG_COLLISION";
    ApiAppErrorCodes["TOPIC_DOES_NOT_EXIST"] = "TOPIC_DOES_NOT_EXIST";
    ApiAppErrorCodes["NON_RECOVERABLE_PROTOCOL_ERROR"] = "NON_RECOVERABLE_PROTOCOL_ERROR";
    ApiAppErrorCodes["BAD_PAYLOAD_FORMAT"] = "BAD_PAYLOAD_FORMAT";
})(ApiAppErrorCodes = exports.ApiAppErrorCodes || (exports.ApiAppErrorCodes = {}));
var ApiCluster;
(function (ApiCluster) {
    ApiCluster["Unknown"] = "Unknown";
    ApiCluster["Legacy"] = "Legacy";
    ApiCluster["Users"] = "Users";
    ApiCluster["Public"] = "Public";
    ApiCluster["Others"] = "Others";
})(ApiCluster = exports.ApiCluster || (exports.ApiCluster = {}));
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var CallbackEventType;
(function (CallbackEventType) {
    CallbackEventType["UNKNOWN"] = "UNKNOWN";
    CallbackEventType["CREATED"] = "CREATED";
    CallbackEventType["UPDATED"] = "UPDATED";
    CallbackEventType["DELETED"] = "DELETED";
    CallbackEventType["ACTION"] = "ACTION";
})(CallbackEventType = exports.CallbackEventType || (exports.CallbackEventType = {}));
var ClusterEnumCluster;
(function (ClusterEnumCluster) {
    ClusterEnumCluster["UNKNOWN_CLUSTER"] = "UNKNOWN_CLUSTER";
    ClusterEnumCluster["LEGACY"] = "LEGACY";
    ClusterEnumCluster["USERS1"] = "USERS1";
    ClusterEnumCluster["PUBLIC1"] = "PUBLIC1";
    ClusterEnumCluster["OTHERS1"] = "OTHERS1";
})(ClusterEnumCluster = exports.ClusterEnumCluster || (exports.ClusterEnumCluster = {}));
var ConsumerType;
(function (ConsumerType) {
    ConsumerType["Regular"] = "Regular";
    ConsumerType["Batch"] = "Batch";
})(ConsumerType = exports.ConsumerType || (exports.ConsumerType = {}));
var DC;
(function (DC) {
    DC["UNKNOWN_DC"] = "UNKNOWN_DC";
    DC["_42"] = "_42";
    DC["_84"] = "_84";
    DC["UW2_EDT_1"] = "UW2_EDT_1";
    DC["UW2_PUB_1"] = "UW2_PUB_1";
})(DC = exports.DC || (exports.DC = {}));
var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["Direct"] = "Direct";
    DeliveryMethod["SidecarV0"] = "SidecarV0";
})(DeliveryMethod = exports.DeliveryMethod || (exports.DeliveryMethod = {}));
var DomainEventEventType;
(function (DomainEventEventType) {
    DomainEventEventType["UNKNOWN"] = "UNKNOWN";
    DomainEventEventType["CREATED"] = "CREATED";
    DomainEventEventType["UPDATED"] = "UPDATED";
    DomainEventEventType["DELETED"] = "DELETED";
    DomainEventEventType["ACTION"] = "ACTION";
})(DomainEventEventType = exports.DomainEventEventType || (exports.DomainEventEventType = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var FailType;
(function (FailType) {
    FailType["NO_ERROR"] = "NO_ERROR";
    FailType["TIMESTAMP_INVALID"] = "TIMESTAMP_INVALID";
    FailType["ORIGINAL_SPEC_NOT_FOUND"] = "ORIGINAL_SPEC_NOT_FOUND";
    FailType["TEMP_GROUP_ALREADY_EXISTS"] = "TEMP_GROUP_ALREADY_EXISTS";
    FailType["OFFSETS_NOT_FOUND"] = "OFFSETS_NOT_FOUND";
    FailType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(FailType = exports.FailType || (exports.FailType = {}));
var FailureReason;
(function (FailureReason) {
    FailureReason["FAILURE_REASON_UNDEFINED"] = "FAILURE_REASON_UNDEFINED";
    FailureReason["TOPIC_WITH_NO_VCLUSTER"] = "TOPIC_WITH_NO_VCLUSTER";
    FailureReason["NO_CLUSTER_IN_DC"] = "NO_CLUSTER_IN_DC";
    FailureReason["INVALID_TOPIC_NAME"] = "INVALID_TOPIC_NAME";
    FailureReason["TOPIC_PERMISSION_DENIED"] = "TOPIC_PERMISSION_DENIED";
})(FailureReason = exports.FailureReason || (exports.FailureReason = {}));
var FieldDescriptorProtoType;
(function (FieldDescriptorProtoType) {
    FieldDescriptorProtoType["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    FieldDescriptorProtoType["TYPE_FLOAT"] = "TYPE_FLOAT";
    FieldDescriptorProtoType["TYPE_INT64"] = "TYPE_INT64";
    FieldDescriptorProtoType["TYPE_UINT64"] = "TYPE_UINT64";
    FieldDescriptorProtoType["TYPE_INT32"] = "TYPE_INT32";
    FieldDescriptorProtoType["TYPE_FIXED64"] = "TYPE_FIXED64";
    FieldDescriptorProtoType["TYPE_FIXED32"] = "TYPE_FIXED32";
    FieldDescriptorProtoType["TYPE_BOOL"] = "TYPE_BOOL";
    FieldDescriptorProtoType["TYPE_STRING"] = "TYPE_STRING";
    FieldDescriptorProtoType["TYPE_GROUP"] = "TYPE_GROUP";
    FieldDescriptorProtoType["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    FieldDescriptorProtoType["TYPE_BYTES"] = "TYPE_BYTES";
    FieldDescriptorProtoType["TYPE_UINT32"] = "TYPE_UINT32";
    FieldDescriptorProtoType["TYPE_ENUM"] = "TYPE_ENUM";
    FieldDescriptorProtoType["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    FieldDescriptorProtoType["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    FieldDescriptorProtoType["TYPE_SINT32"] = "TYPE_SINT32";
    FieldDescriptorProtoType["TYPE_SINT64"] = "TYPE_SINT64";
})(FieldDescriptorProtoType = exports.FieldDescriptorProtoType || (exports.FieldDescriptorProtoType = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
    Format["URL_SLUG"] = "URL_SLUG";
    Format["SYSTEM_SLUG"] = "SYSTEM_SLUG";
    Format["SECURE_WEB_URL"] = "SECURE_WEB_URL";
    Format["SUBDIVISION"] = "SUBDIVISION";
})(Format = exports.Format || (exports.Format = {}));
var HeaderOperator;
(function (HeaderOperator) {
    HeaderOperator["UNKNOWN"] = "UNKNOWN";
    HeaderOperator["EQUALS"] = "EQUALS";
    HeaderOperator["NOT_EQUALS"] = "NOT_EQUALS";
    HeaderOperator["PRESENT"] = "PRESENT";
    HeaderOperator["ABSENT"] = "ABSENT";
    HeaderOperator["CONTAINS"] = "CONTAINS";
    HeaderOperator["NOT_CONTAINS"] = "NOT_CONTAINS";
})(HeaderOperator = exports.HeaderOperator || (exports.HeaderOperator = {}));
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode["OK"] = "OK";
    HttpStatusCode["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    HttpStatusCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    HttpStatusCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    HttpStatusCode["NOT_FOUND"] = "NOT_FOUND";
    HttpStatusCode["INTERNAL"] = "INTERNAL";
    HttpStatusCode["UNAVAILABLE"] = "UNAVAILABLE";
    HttpStatusCode["RESOURCE_EXHAUSTED"] = "RESOURCE_EXHAUSTED";
    HttpStatusCode["CANCELED"] = "CANCELED";
    HttpStatusCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    HttpStatusCode["FAILED_PRECONDITION"] = "FAILED_PRECONDITION";
})(HttpStatusCode = exports.HttpStatusCode || (exports.HttpStatusCode = {}));
var IdempotencyLevel;
(function (IdempotencyLevel) {
    IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(IdempotencyLevel = exports.IdempotencyLevel || (exports.IdempotencyLevel = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
    Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var MessageAppendixType;
(function (MessageAppendixType) {
    MessageAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    MessageAppendixType["AUTO_VELO"] = "AUTO_VELO";
    MessageAppendixType["DOCS_CONF"] = "DOCS_CONF";
    MessageAppendixType["MULTILINGUAL"] = "MULTILINGUAL";
    MessageAppendixType["SEARCH"] = "SEARCH";
    MessageAppendixType["AUTO_SDK"] = "AUTO_SDK";
})(MessageAppendixType = exports.MessageAppendixType || (exports.MessageAppendixType = {}));
var Method;
(function (Method) {
    Method["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    Method["CREATE"] = "CREATE";
    Method["GET_ITEM"] = "GET_ITEM";
    Method["UPDATE"] = "UPDATE";
    Method["DELETE"] = "DELETE";
    Method["UPSERT"] = "UPSERT";
    Method["LIST"] = "LIST";
    Method["QUERY"] = "QUERY";
    Method["SEARCH"] = "SEARCH";
    Method["BULK_CREATE"] = "BULK_CREATE";
    Method["BULK_UPDATE"] = "BULK_UPDATE";
    Method["BULK_UPDATE_BY_FILTER"] = "BULK_UPDATE_BY_FILTER";
    Method["BULK_DELETE"] = "BULK_DELETE";
    Method["BULK_DELETE_BY_FILTER"] = "BULK_DELETE_BY_FILTER";
    Method["BULK_UPSERT"] = "BULK_UPSERT";
    Method["LIST_DELETED"] = "LIST_DELETED";
    Method["GET_DELETED"] = "GET_DELETED";
    Method["RESTORE_FROM_TRASHBIN"] = "RESTORE_FROM_TRASHBIN";
    Method["REMOVE_FROM_TRASHBIN"] = "REMOVE_FROM_TRASHBIN";
    Method["COUNT"] = "COUNT";
    Method["SEARCH_RELATED"] = "SEARCH_RELATED";
    Method["UPDATE_EXTENDED_FIELDS"] = "UPDATE_EXTENDED_FIELDS";
    Method["BULK_UPDATE_TAGS"] = "BULK_UPDATE_TAGS";
    Method["BULK_UPDATE_TAGS_BY_FILTER"] = "BULK_UPDATE_TAGS_BY_FILTER";
    Method["CUSTOM_ACTION"] = "CUSTOM_ACTION";
})(Method = exports.Method || (exports.Method = {}));
var NullValue;
(function (NullValue) {
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue = exports.NullValue || (exports.NullValue = {}));
var OffsetReset;
(function (OffsetReset) {
    OffsetReset["Unspecified"] = "Unspecified";
    OffsetReset["Earliest"] = "Earliest";
    OffsetReset["Latest"] = "Latest";
})(OffsetReset = exports.OffsetReset || (exports.OffsetReset = {}));
var Operator;
(function (Operator) {
    Operator["ALL_APPLICABLE_OPERATORS"] = "ALL_APPLICABLE_OPERATORS";
    Operator["EQ"] = "EQ";
    Operator["GT"] = "GT";
    Operator["GTE"] = "GTE";
    Operator["IN"] = "IN";
    Operator["LT"] = "LT";
    Operator["LTE"] = "LTE";
    Operator["NE"] = "NE";
    Operator["NIN"] = "NIN";
    Operator["BEGINS"] = "BEGINS";
    Operator["EXISTS"] = "EXISTS";
    Operator["HAS_ALL"] = "HAS_ALL";
    Operator["ALL"] = "ALL";
    Operator["HAS_SOME"] = "HAS_SOME";
    Operator["ANY"] = "ANY";
    Operator["EMPTY"] = "EMPTY";
    Operator["MATCH_ALL"] = "MATCH_ALL";
    Operator["MATCH_ITEMS"] = "MATCH_ITEMS";
    Operator["ENHANCED_DATE"] = "ENHANCED_DATE";
})(Operator = exports.Operator || (exports.Operator = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var Ordering;
(function (Ordering) {
    Ordering["Partition"] = "Partition";
    Ordering["Key"] = "Key";
})(Ordering = exports.Ordering || (exports.Ordering = {}));
var PagingType;
(function (PagingType) {
    PagingType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    PagingType["OFFSET"] = "OFFSET";
    PagingType["CURSOR"] = "CURSOR";
    PagingType["BOTH"] = "BOTH";
})(PagingType = exports.PagingType || (exports.PagingType = {}));
var PartitionStatusStatus;
(function (PartitionStatusStatus) {
    PartitionStatusStatus["PENDING"] = "PENDING";
    PartitionStatusStatus["SUCCESS"] = "SUCCESS";
    PartitionStatusStatus["STALE"] = "STALE";
    PartitionStatusStatus["ERROR"] = "ERROR";
})(PartitionStatusStatus = exports.PartitionStatusStatus || (exports.PartitionStatusStatus = {}));
var PermissionType;
(function (PermissionType) {
    PermissionType["AUTO"] = "AUTO";
    PermissionType["MANUAL"] = "MANUAL";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
var PersistenceType;
(function (PersistenceType) {
    PersistenceType["STANDARD"] = "STANDARD";
    PersistenceType["SINGLETON"] = "SINGLETON";
    PersistenceType["NONE"] = "NONE";
})(PersistenceType = exports.PersistenceType || (exports.PersistenceType = {}));
var ProxyDeployment;
(function (ProxyDeployment) {
    ProxyDeployment["UNKNOWN_PROXY_DEPLOYMENT"] = "UNKNOWN_PROXY_DEPLOYMENT";
    ProxyDeployment["PROD"] = "PROD";
    ProxyDeployment["STAGING"] = "STAGING";
    ProxyDeployment["POC2"] = "POC2";
    ProxyDeployment["CANARY"] = "CANARY";
    ProxyDeployment["SENSITIVE"] = "SENSITIVE";
})(ProxyDeployment = exports.ProxyDeployment || (exports.ProxyDeployment = {}));
var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["REGISTRATION_STATUS_UNDEFINED"] = "REGISTRATION_STATUS_UNDEFINED";
    RegistrationStatus["SUCCESS"] = "SUCCESS";
    RegistrationStatus["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
})(RegistrationStatus = exports.RegistrationStatus || (exports.RegistrationStatus = {}));
var ResetOffsetType;
(function (ResetOffsetType) {
    ResetOffsetType["EARLIEST"] = "EARLIEST";
    ResetOffsetType["LATEST"] = "LATEST";
})(ResetOffsetType = exports.ResetOffsetType || (exports.ResetOffsetType = {}));
var SegmentName;
(function (SegmentName) {
    SegmentName["UNSPECIFIED"] = "UNSPECIFIED";
    SegmentName["USERS"] = "USERS";
    SegmentName["PUBLIC"] = "PUBLIC";
    SegmentName["OTHERS"] = "OTHERS";
})(SegmentName = exports.SegmentName || (exports.SegmentName = {}));
var ServiceAppendixType;
(function (ServiceAppendixType) {
    ServiceAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    ServiceAppendixType["NILE"] = "NILE";
    ServiceAppendixType["MESSAGE_BUS"] = "MESSAGE_BUS";
})(ServiceAppendixType = exports.ServiceAppendixType || (exports.ServiceAppendixType = {}));
var Sort;
(function (Sort) {
    Sort["NONE"] = "NONE";
    Sort["ASC"] = "ASC";
    Sort["DESC"] = "DESC";
    Sort["BOTH"] = "BOTH";
})(Sort = exports.Sort || (exports.Sort = {}));
var TranslatableType;
(function (TranslatableType) {
    TranslatableType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    TranslatableType["SHORT_TEXT"] = "SHORT_TEXT";
    TranslatableType["LONG_TEXT"] = "LONG_TEXT";
    TranslatableType["RICH_TEXT"] = "RICH_TEXT";
    TranslatableType["RICH_CONTENT_EDITOR"] = "RICH_CONTENT_EDITOR";
    TranslatableType["SELECTION"] = "SELECTION";
    TranslatableType["MULTI_SELECTION"] = "MULTI_SELECTION";
    TranslatableType["DOCUMENT"] = "DOCUMENT";
    TranslatableType["IMAGE"] = "IMAGE";
    TranslatableType["VIDEO"] = "VIDEO";
    TranslatableType["IMAGE_LINK"] = "IMAGE_LINK";
})(TranslatableType = exports.TranslatableType || (exports.TranslatableType = {}));
var V1AppErrorCodes;
(function (V1AppErrorCodes) {
    V1AppErrorCodes["UNKNOWN"] = "UNKNOWN";
    V1AppErrorCodes["HANDLER_FAILED"] = "HANDLER_FAILED";
    V1AppErrorCodes["BAD_PAYLOAD_FORMAT"] = "BAD_PAYLOAD_FORMAT";
    V1AppErrorCodes["HANDLER_FAILED_SEND_TO_DLQ"] = "HANDLER_FAILED_SEND_TO_DLQ";
    V1AppErrorCodes["HANDLER_FAILED_UNEXPECTED"] = "HANDLER_FAILED_UNEXPECTED";
})(V1AppErrorCodes = exports.V1AppErrorCodes || (exports.V1AppErrorCodes = {}));
var VirtualSubfields;
(function (VirtualSubfields) {
    VirtualSubfields["NO_VIRTUAL_SUBFIELDS"] = "NO_VIRTUAL_SUBFIELDS";
    VirtualSubfields["DATE"] = "DATE";
    VirtualSubfields["EMAIL"] = "EMAIL";
})(VirtualSubfields = exports.VirtualSubfields || (exports.VirtualSubfields = {}));
//# sourceMappingURL=types.js.map